import React, { useMemo, useState } from "react";
import useCalculatorResults from "../hooks/useCalculatorResults";

const CalculationImportPanel = ({ targetCalculatorId, targetUnits = "imperial", onApply }) => {
  const { compatibleResults } = useCalculatorResults(targetCalculatorId, targetUnits);
  const [selectedIndex, setSelectedIndex] = useState(0);

  const selected = useMemo(
    () => compatibleResults[selectedIndex] || null,
    [compatibleResults, selectedIndex]
  );

  if (!compatibleResults.length) return null;

  const apply = () => {
    if (!selected) return;
    const values = selected.fields.reduce((next, field) => {
      next[field.targetField] = field.value;
      return next;
    }, {});

    const message = [
      "Import these fields into this calculator?",
      ...selected.fields.map((field) => `- ${field.label}: ${Array.isArray(field.value) ? `${field.value.length} items` : field.value}${field.converted ? ` (${field.sourceUnits} converted to ${field.targetUnits})` : ""}`),
    ].join("\n");

    if (window.confirm(message)) {
      onApply?.({
        values,
        lineage: selected.lineage,
        sourceResult: selected.result,
        mapping: selected.mapping,
      });
    }
  };

  return (
    <section className="calculation-import-panel">
      <div>
        <h3>Import Calculation</h3>
        <p>Pull compatible fields from a recent calculator result without retyping shop data.</p>
      </div>
      <label className="form-group">
        Previous result
        <select value={selectedIndex} onChange={(event) => setSelectedIndex(Number(event.target.value))}>
          {compatibleResults.map((candidate, index) => (
            <option key={`${candidate.result.id}-${candidate.mapping.label}`} value={index}>
              {candidate.result.calculatorName} - {candidate.mapping.label}
            </option>
          ))}
        </select>
      </label>
      {selected && (
        <div className="calculation-import-preview">
          <strong>{selected.mapping.confidence} compatibility</strong>
          <ul>
            {selected.fields.map((field) => (
              <li key={`${field.sourceField}-${field.targetField}`}>
                {field.label}: {Array.isArray(field.value) ? `${field.value.length} items` : String(field.value)}
                {field.converted ? ` (${field.sourceUnits} to ${field.targetUnits})` : ""}
              </li>
            ))}
          </ul>
          <p>{selected.lineage}</p>
        </div>
      )}
      <button type="button" className="btn-secondary" onClick={apply}>
        Use Previous Result
      </button>
    </section>
  );
};

export default CalculationImportPanel;
